export const DepartmentIds = Object.freeze({
  LIQUOR: 1,
  TOBACCO: 22,
  MENU: 'Menu',
});
